// @Conf
// #hasDoc=true

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2024-10-23T13:08:09Z                      #

// ##############################################################

export enum ModuleCode {
/**
 * MC řešení.
 */
    MARBES = 'MARBES',
/**
 * HSM - cesnet.
 */
    HSM = 'HSM',
/**
 * HSM - ica.
 */
    ICA = 'ICA',
/**
 * HSM - secusign
 */
    SECUSIGN = 'SECUSIGN'}



/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
const params = {
    [ModuleCode.MARBES]: {caption: 'MC řešení.'},
    [ModuleCode.HSM]: {caption: 'HSM - cesnet.'},
    [ModuleCode.ICA]: {caption: 'HSM - ica.'},
    [ModuleCode.SECUSIGN]: {caption: 'HSM - secusign'}
};

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
export function getCaption(value) {
    return params[value].caption;
}
